import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import { environment } from './environments/environment';
import { applyInitialColorSchemeFromStorage } from '@techcrowd/tokens';

// Register Czech locale
registerLocaleData(localeCs);

// Prevent light→dark flash before Angular boots.
applyInitialColorSchemeFromStorage();

/**
 * BA-348: runtime přepínání API bez rebuildu FE.
 * Na Brinks IIS běží jedna FE adresa nad dvěma BE (api-ai-test = stage,
 * api-ai = prod) a URL je jinak zapečená v buildu (environment.proddev.ts).
 * Když vedle index.html leží config.json s {"apiUrl": "..."}, přebije
 * hodnotu z buildu; chybějící nebo vadný soubor = beze změny chování.
 * Relativní fetch respektuje <base href>, na IIS tedy /billing/config.json.
 */
async function loadRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch('config.json', { cache: 'no-store' });
    if (!res.ok) return;
    const cfg: { apiUrl?: unknown } = await res.json();
    if (typeof cfg.apiUrl === 'string' && cfg.apiUrl.trim()) {
      environment.apiUrl = cfg.apiUrl.trim().replace(/\/+$/, '');
      console.info(`[config] apiUrl z config.json: ${environment.apiUrl}`);
    }
  } catch {
    // config.json neexistuje / není JSON — platí URL z buildu
  }
}

loadRuntimeConfig().then(() =>
  bootstrapApplication(App, appConfig).catch((err) => console.error(err)),
);
